
import Range from 'vux/src/components/range/index.vue'

export default {
components: {
Range
},
data() {
return {
data1: 0
}
},
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-range.vue